module.exports = __webpack_public_path__ + "static/media/modifyIcon.af7e5fd1.svg";